import React, { Component } from 'react';
import { connect } from 'react-redux';
import { showAllPhotoPopup } from '../../actions/allphoto/index';
import { FontAwesomeIcon } from '../../../node_modules/@fortawesome/react-fontawesome';
import _ from 'lodash';

class AllPhoto extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showAllPhoto: false,
            imageUrl: '',
            showImage: false,
            firstname: '',
            lastname: '',
            comment: ''
        }

        this.renderPhoto = this.renderPhoto.bind(this);
    }

    renderPhoto(comment) {
        const image = _.map(comment, (comment, index) => {
            let result = [];

            if (comment.img_url1) {
                if (comment.img_url1.trim() !== "") {
                    result.push(
                        <div key={index + "_1"} className="col-6 col-xl-3 col-md-4" style={{marginBottom: "15px"}}>
                            <div className="w-100 padding-top-100" style={{ background: `url(${comment.img_url1})`, backgroundSize: "cover", backgroundPosition: "center center", cursor: "pointer"}} onClick={() => this.setState({ imageUrl: comment.img_url1, firstname: comment.first_name, lastname: comment.last_name, comment: comment.comment, showImage: true })}></div>
                            {/* <img className="zoom" alt="" src={comment.img_url1} width="150px" height="150px" style={{ margin: "auto", display: "block" }} onClick={() => this.setState({ imageUrl: comment.img_url1, firstname: comment.first_name, lastname: comment.last_name, comment: comment.comment, showImage: true })} /> */}
                        </div>
                    )
                }
            }
            if (comment.img_url2) {
                if (comment.img_url2.trim() !== "") {
                    result.push(
                        <div key={index + "_2"} className="col-6 col-xl-3 col-md-4" style={{marginBottom: "15px"}}>
                            <div className="w-100 padding-top-100" style={{ background: `url(${comment.img_url2})`, backgroundSize: "cover", backgroundPosition: "center center", cursor: "pointer"}} onClick={() => this.setState({ imageUrl: comment.img_url2, firstname: comment.first_name, lastname: comment.last_name, comment: comment.comment, showImage: true })}></div>
                            {/* <img className="zoom" alt="" src={comment.img_url2} width="150px" height="150px" style={{ margin: "auto", display: "block" }} onClick={() => this.setState({ imageUrl: comment.img_url2, firstname: comment.first_name, lastname: comment.last_name, comment: comment.comment, showImage: true })} /> */}
                        </div>
                    )
                }
            }
            return result;
        })
        return image;
    }

    render() {
        const { visible, comment } = this.props;

        if (visible) {
            return (
                <div className="bt-popup-backdrop" >
                    <div className="bt-popup bt-popup-photoreview all-photo" >
                        <div>
                            <div className="header-allphoto">
                                <label className="btn-close" onClick={() => this.props.setVisible(false)}><FontAwesomeIcon icon={["fal", "times"]} /></label>
                                <h4>ภาพทั้งหมด</h4>
                            </div>
                        </div>

                        <div className="container" onClick={(e) => e.stopPropagation()}>                  
                            <div className="grid-photo">
                                {this.renderPhoto(comment)}
                            </div>
                        </div>
                    </div>
                    {this.state.showImage &&
                        <div style={{ width: "100vw", height: "100vh", background: "rgba(0, 0, 0, 0.8)", position: "fixed", zIndex: "1060", padding: "5%", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }} onClick={(e) => { this.setState({ showImage: false }); e.stopPropagation(); }}>
                            <img alt="" src={this.state.imageUrl} className="zoominImage" onClick={() => this.setState({ showImage: false })} />
                            <div className="comment mt-4 zoomIn-comment">
                                <div style={{ fontWeight: "bold", margin: "0" }} className="row">
                                    {this.state.firstname} {this.state.lastname}
                                </div><br />
                                <div className="row" style={{ margin: "0" }}>
                                    {this.state.comment}
                                </div>
                            </div>
                        </div>
                    }
                </div>
            );
        }
        else {
            return null;
        }
    }
}

function mapStateToProps(state) {
    return {
        material: state.materials.material,
    }
}
export default connect(mapStateToProps, { showAllPhotoPopup })(AllPhoto)